import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import theme from '../styles/theme';

const Palette = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Palette;
